/**
 * The db_status vocabulary, shared by every consumer.
 *
 * The four swatches used to be re-typed by hand in ChatSidebarSearch,
 * DbStatusSelector and DbStatusIndicator. They are identical in the Telegram
 * dark and light palettes, so they are defined here and `telegramColors.ts`
 * pulls them into `TelegramTheme` — not the reverse.
 */

import { DbStatus } from '@/types/api';

export const DB_STATUS_VALUES: DbStatus[] = [
  'in_db',
  'not_in_db',
  'we_have_more',
  'channel_has_more',
];

export const DB_STATUS_COLORS: Record<DbStatus, string> = {
  in_db: '#4caf50',
  not_in_db: '#9e9e9e',
  we_have_more: '#2196f3',
  channel_has_more: '#ff9800',
};

/** Translation key for a status label, in the `pages` namespace. */
export const dbStatusLabelKey = (status: DbStatus): string =>
  `chatPreview.annotations.dbStatusOptions.${status}`;
